import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Resultdrivenitstaff() {
  return (
    <section
      className="result_driven_it_staff p-100"
      style={{ background: "#132235" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>Result-Driven IT Staff Augmentation Company</h2>
            <h5>Excellence in Every Project</h5>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
            <p>
              With over 100 staff augmentation projects successfully delivered
              across 20+ industry sectors, TekRevol sets the standard for IT
              staff augmentation services. Our commitment to quality and client
              success is demonstrated through numerous awards and recognitions.
            </p>
            <Link
              to="/contact"
              className="border_btn web_case_btn"
              aria-label="TekRevol Contact"
            >
              Consult Your Staffing Needs
            </Link>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={6} md={3} lg={3} xl={3} xxl={3}>
            <div className="result_driven_box">
              <h2>150+</h2>
              <p>Team Members</p>
            </div>
          </Col>
          <Col xs={6} md={3} lg={3} xl={3} xxl={3}>
            <div className="result_driven_box">
              <h2>100+</h2>
              <p>Projects Delivered</p>
            </div>
          </Col>
          <Col xs={6} md={3} lg={3} xl={3} xxl={3}>
            <div className="result_driven_box">
              <h2>100%</h2>
              <p>On-Time Delivery Rate</p>
            </div>
          </Col>
          <Col xs={6} md={3} lg={3} xl={3} xxl={3}>
            <div className="result_driven_box">
              <h2>98.6%</h2>
              <p>Client Satisfaction Rate</p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Resultdrivenitstaff;
